export const NAME = 'contactsList';

export const COLLAPSIBLE_TABLE_NAME = 'ContactsTable';

export const REPORT_NOT_FOUND_DIALOG = `${NAME}/REPORT_NOT_FOUND_DIALOG`;

export const bruttoProdStatusValues = {
	DEFAULT: 'DEFAULT',
	PAIRED: 'PAIRED',
	NOT_PAIRED: 'NOT_PAIRED',
};

export const SUCCESSFULLY_EXECUTED_CONTACT_STATE = '602';
